import { useState } from "react";
import { Lock, Loader2 } from "lucide-react";

const API = "";

export default function Login({ onLoginSuccess }) {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!username.trim() || !password) return;

        setLoading(true);
        setError(null);
        try {
            const res = await fetch(`${API}/api/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ username: username.trim(), password }),
            });
            const data = await res.json();

            if (!res.ok) {
                setError(data.error || "Не удалось войти");
                return;
            }

            localStorage.setItem("ppa_token", data.token);
            onLoginSuccess(data.token);
        } catch {
            setError("Сервер недоступен");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="ppa-login-root">
            <form onSubmit={handleSubmit} className="ppa-login-card">
                <div className="ppa-login-icon">
                    <Lock size={20} />
                </div>
                <h1 className="ppa-login-title">Вход в админку</h1>

                {error && <div className="ppa-error">{error}</div>}

                <div className="ppa-field">
                    <label className="ppa-label">Логин</label>
                    <input
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        autoFocus
                        className="ppa-input"
                    />
                </div>

                <div className="ppa-field">
                    <label className="ppa-label">Пароль</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="ppa-input"
                    />
                </div>

                <button
                    type="submit"
                    disabled={loading || !username.trim() || !password}
                    className="ppa-btn ppa-btn-primary ppa-login-submit"
                >
                    {loading ? <Loader2 size={16} className="ppa-spin" /> : "Войти"}
                </button>
            </form>
        </div>
    );
}